<template>
    <Card class="marketing-preferences-campaigns__container">
        <preloader :display="isLoading" />
        <h2 class="marketing-preferences-campaigns__title typographies-heading-h2">
            {{ labels.maintTitle }}
        </h2>

        <div class="marketing-preferences-campaigns__default-subscription">
            <h3
                class="marketing-preferences-campaigns__default-subscription-title typographies-heading-h3"
            >
                {{ labels.defaultConsent.title }}
            </h3>

            <CompassSwitch
                v-model="defaultConsent"
                :label="labels.defaultConsent.switch"
                class="marketing-preferences-campaigns__default-subscription-switch"
                orientation="left"
                @change="updateConsent(false)"
            />

            <p
                class="marketing-preferences-campaigns__default-subscription-informations typographies-paragraph-medium-regular"
                v-html="labels.defaultConsent.informations"
            />
        </div>

        <div class="marketing-preferences-campaigns__confirm-subscription">
            <h3
                class="marketing-preferences-campaigns__confirm-subscription-title typographies-heading-h3"
            >
                {{ labels.doubleOptin.title }}
            </h3>

            <CompassSwitch
                v-model="doubleOptin.enable"
                :label="labels.doubleOptin.switch"
                class="marketing-preferences-campaigns__confirm-subscription-switch"
                orientation="left"
                @change="updateConsent(false)"
            />

            <p
                class="marketing-preferences-campaigns__confirm-subscription-informations typographies-paragraph-medium-regular"
            >
                {{ labels.doubleOptin.informations }}
            </p>

            <div
                v-if="doubleOptin.enable"
                class="marketing-preferences-campaigns__confirm-subscription-more"
            >
                <CompassAlert
                    :showClose="false"
                    :description="labels.doubleOptin.alert"
                    class="marketing-preferences-campaigns__confirm-subscription-more-alert"
                />

                <div class="marketing-preferences-campaigns__confirm-subscription-more-form">
                    <CompassFormItem :label="labels.doubleOptin.form.email">
                        <CompassInput v-model="doubleOptin.confirmEmail.sender.email" />
                    </CompassFormItem>

                    <CompassFormItem :label="labels.doubleOptin.form.sender">
                        <CompassInput v-model="doubleOptin.confirmEmail.sender.name" />
                    </CompassFormItem>

                    <CompassFormItem :label="labels.doubleOptin.form.object">
                        <CompassInput v-model="doubleOptin.confirmEmail.subject" />
                    </CompassFormItem>

                    <CompassFormItem :label="labels.doubleOptin.form.label">
                        <RichText
                            v-model="doubleOptin.confirmEmail.body"
                            :options="optionsRichText"
                            class="custom-richtext"
                        />
                    </CompassFormItem>

                    <CompassFormItem :label="labels.doubleOptin.form.button">
                        <CompassInput v-model="doubleOptin.confirmEmail.button.label" />
                    </CompassFormItem>

                    <div
                        class="marketing-preferences-campaigns__confirm-subscription-more-form-buttons"
                    >
                        <CompassButton
                            :label="labels.doubleOptin.save"
                            @click="updateConsent(true)"
                        />
                    </div>
                </div>
            </div>
        </div>
    </Card>
</template>

<script>
import Preloader from 'vcomponents/utilities/Preloader.vue';
import RichText from 'vcomponents/richtext/RichText.vue';
import Card from 'vcomponents/common/card/Card.vue';
import marketingService from 'vueDir/api/marketing/marketingService.js';

export default {
    components: { Card, Preloader, RichText },
    data() {
        return {
            isLoading: false,
            defaultConsent: false,
            doubleOptin: {
                enable: false,
                confirmEmail: {
                    subject: '',
                    body: '',
                    sender: {
                        email: '',
                        name: '',
                    },
                    button: {
                        label: '',
                    },
                },
            },
            optionsRichText: [
                'Bold',
                'Italic',
                'Underline',
                'TextAlign',
                'BulletList',
                'OrderedList',
                'Divider',
                'Link',
            ],
            labels: {
                maintTitle: this.$l10n.__("Préférences d'inscriptions marketing"),
                defaultConsent: {
                    title: this.$l10n.__("Gestion de l'inscription aux campagnes"),
                    switch: this.$l10n.__('Inscrit par défaut aux campagnes marketing'),
                    informations: this.$l10n.__(
                        'En activant cette option, tout contact ou société que vous ajouterez manuellement (hors API / formulaire / import) sera considéré comme acceptant de recevoir vos campagnes marketing (emails et SMS). Vous pourrez les inscrire et désinscrire à tout moment.%(br)s%(br)sDe leur côté, les destinataires de vos campagnes pourront se désinscrire depuis les campagnes marketing qu’ils receveront. Ces désinscriptions seront automatiquement mises à jour.',
                        { br: '<br>' },
                    ),
                },
                doubleOptin: {
                    title: this.$l10n.__("Confirmation de mise à jour d'inscription aux campagnes"),
                    switch: this.$l10n.__(
                        "Activer la confirmation d'inscription aux campagnes marketing (double opt-in)",
                    ),
                    informations: this.$l10n.__(
                        'Si vous activez cette option, un email sera automatiquement envoyé à vos contacts pour qu’ils confirment leur volonté de recevoir vos campagnes marketing.',
                    ),
                    alert: this.$l10n.__(
                        'Tant qu’ils n’ont pas validé leur inscription, ils seront considérés comme désinscrits.',
                    ),
                    form: {
                        email: this.$l10n.__('Adresse email de réponse'),
                        sender: this.$l10n.__("Nom de l'expéditeur de l'email"),
                        object: this.$l10n.__('Objet'),
                        label: this.$l10n.__('Label'),
                        button: this.$l10n.__('Texte du bouton de confirmation'),
                    },
                    save: this.$l10n.__('Enregistrer'),
                },
            },
        };
    },
    beforeMount() {
        this.getConsentDatas();
    },
    methods: {
        getConsentDatas() {
            this.isLoading = true;
            marketingService
                .getConsentDatas()
                .then((response) => {
                    const doubleOptinResponse = response.data.settings['double_optin'];
                    this.defaultConsent = response.data.settings['default_consent'];
                    this.doubleOptin = {
                        enable: doubleOptinResponse.enable,
                        confirmEmail: {
                            subject: doubleOptinResponse['confirm_email'].subject,
                            body: doubleOptinResponse['confirm_email'].body,
                            sender: {
                                email: doubleOptinResponse['confirm_email'].sender.email,
                                name: doubleOptinResponse['confirm_email'].sender.name,
                            },
                            button: {
                                label: doubleOptinResponse['confirm_email'].button.label,
                            },
                        },
                    };
                })
                .catch(() => {
                    this.$pushToast({
                        type: 'error',
                        icon: true,
                        text: this.$l10n.__('Une erreur est survenue, merci de réessayer'),
                    });
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        updateConsent(needLoading) {
            this.isLoading = needLoading;
            marketingService
                .updateConsent({
                    default_consent: this.defaultConsent,
                    double_optin: {
                        enable: this.doubleOptin.enable,
                        confirm_email: {
                            subject: this.doubleOptin.confirmEmail.subject,
                            body: this.doubleOptin.confirmEmail.body,
                            sender: {
                                email: this.doubleOptin.confirmEmail.sender.email,
                                name: this.doubleOptin.confirmEmail.sender.name,
                            },
                            button: {
                                label: this.doubleOptin.confirmEmail.button.label,
                            },
                        },
                    },
                })
                .then(() => {
                    this.$pushToast({
                        type: 'success',
                        icon: true,
                        text: this.$l10n.__(
                            "Vos préférences d'inscriptions marketing ont bien été modifiées",
                        ),
                    });
                })
                .catch(() => {
                    this.$pushToast({
                        type: 'error',
                        icon: true,
                        text: this.$l10n.__('Une erreur est survenue, merci de réessayer'),
                    });
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
    },
};
</script>

<style lang="scss" scoped>
.marketing-preferences-campaigns {
    &__container {
        ::v-deep {
            .preloader {
                position: fixed;
                height: 100vh;
            }
        }
    }

    &__title {
        margin: 0 0 var(--spacing-3);
    }

    &__default-subscription,
    &__confirm-subscription {
        margin: 0 0 var(--spacing-5);

        &-title {
            margin: 0 0 var(--spacing-1);
        }

        &-switch {
            margin: 0 0 var(--spacing-3);

            &::v-deep {
                label {
                    justify-content: flex-end;
                }
            }
        }

        &-informations {
            margin: 0 0 var(--spacing-3);
        }
    }

    &__confirm-subscription {
        &-more {
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            gap: var(--spacing-5);

            &-alert {
                width: 100%;
            }

            &-form {
                width: 480px;
                display: flex;
                flex-direction: column;
                gap: var(--spacing-3);

                &-buttons {
                    display: flex;
                    align-items: center;
                    justify-content: flex-end;
                    gap: var(--spacing-2);
                }
            }
        }
    }
}
</style>
